export const ErrorObjects: any = {
	Notfound: {
		response: {
			status: 404,
		},
	},
};
